import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {useTranslation} from '@/translations/i18n'
import {MedicalRecordSearchParams} from '@/features/medical-records/types'
import {useEffect, useState} from 'react'
import {StyledInputSelectProjectWrapper} from './style'
import {InputSelectProjectByPatient} from '@/features/projects/components/input-select-project-by-patient/InputSelectProjectByPatient'
import {ProjectByPatient} from '@/features/projects/types'
import {useGetProject} from '@/features/projects/queries/useGetProject'

export const MedicalRecordProjectFilter = ({patientId}: {patientId: string}) => {
    const {t} = useTranslation()

    const {
        searchParams: {projectId: projectParamId},
        setSearchParams
    } = useParsedSearchParams(MedicalRecordSearchParams)

    const [project, setProject] = useState<ProjectByPatient | null>(null)

    const {data: filteredProject} = useGetProject({
        urlParams: {projectId: projectParamId ?? ''},
        params: {responseType: 'small'},
        options: {enabled: !!projectParamId}
    })

    useEffect(() => {
        if (filteredProject) {
            setProject(filteredProject)
        }
    }, [filteredProject])

    return (
        <StyledInputSelectProjectWrapper>
            <InputSelectProjectByPatient
                patientId={patientId}
                placeholder={t('patients:pri_reference')}
                value={projectParamId && project ? project : null}
                onClear={() => setSearchParams({projectId: undefined})}
                onChange={project => {
                    if (project) {
                        setSearchParams({projectId: project.id.toString()})
                        setProject(project)
                    } else {
                        setSearchParams({projectId: undefined})
                        setProject(null)
                    }
                }}
            />
        </StyledInputSelectProjectWrapper>
    )
}
